import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/logo/logo-bms.webp";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCartShopping, faBars, faXmark } from '@fortawesome/free-solid-svg-icons';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    const newIsOpen = !isOpen;
    setIsOpen(newIsOpen);
    document.body.classList.toggle('menu-open', newIsOpen);
  };

  useEffect(() => {
    const closeMenu = (e) => {
      if (isOpen && !e.target.closest('.header-menu') && !e.target.closest('.burger-menu')) {
        setIsOpen(false);
        document.body.classList.remove('menu-open');
      }
    };

    document.addEventListener('click', closeMenu);
    return () => document.removeEventListener('click', closeMenu);
  }, [isOpen]);

  useEffect(() => {
    if (isOpen) {
      setIsOpen(false);
      document.body.classList.remove('menu-open');
    }
  }, [location]);

  return (
    <>
      <Link to="/" className="header-logo">
        <img src={logo} alt="Logo" className="logo" />
      </Link>

      <button className="burger-menu" onClick={toggleMenu}>
        <FontAwesomeIcon icon={isOpen ? faXmark : faBars} />
      </button>

      <nav className={`header-menu ${isOpen ? 'active' : ''}`}>
        <div className="menu-content">
          <ul className="nav-list">
            <li className="list-item">
              <Link to="/crew" onClick={toggleMenu}>The Crew</Link>
            </li>
            <li className="list-item">
              <Link to="/academy" onClick={toggleMenu}>BMS Academy</Link>
            </li>
            <li className="list-item">
              <Link to="/about" onClick={toggleMenu}>À propos</Link>
            </li>
          </ul>
          <ul className="header-actions mobile">
            <li className="actions-items">
              <a href="https://thebmscrew.com/" target="_blank" className="shop-item" onClick={toggleMenu}>
                <FontAwesomeIcon icon={faCartShopping} /><span>Boutique</span>
              </a>
            </li>
          </ul>
        </div>
      </nav>

      <ul className="header-actions desktop">
        <li className="actions-items">
          <a href="https://thebmscrew.com/" target="_blank" className="shop-item">
            <FontAwesomeIcon icon={faCartShopping} /><span>Boutique</span>
          </a>
        </li>
      </ul>
    </>
  );
}

export default Navbar;